// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from 'axios';
// import {toast, ToastContainer} from 'react-toastify';


// // const Login = ({ handleClose, onLoginSuccess  }) => {
// const Login = ({ handleClose }) => {

// const [loginField, setLoginField]  = useState({"userName":"", "password":""});
//   const [loading, setLoading] = useState(false);
// const navigate = useNavigate();

//   const handleLogin = async () => {

//     if (!loginField.userName || !loginField.password) {
//       toast.error("All fields are required");
//       return;
//     }

//     try {
//       setLoading(true);

//       const response = await axios.post(
//         `${process.env.REACT_APP_FRONTEND_URL}/auth/login`,
//         loginField,
//         { withCredentials: true }
//       );

//       const { trego, token, subscriptionActive } = response.data;

//       // ✅ Save in localStorage
//       localStorage.setItem("tregoName", trego.tregoName || "");
//       localStorage.setItem("profilePic", trego.profilePic || "");
//       localStorage.setItem("token", token);
//       localStorage.setItem("isLogin", "true");

// // ✅ Set subscription expiry in localStorage if available
// if (trego.subscriptionExpiry) {
//   localStorage.setItem("subscriptionExpiry", trego.subscriptionExpiry);
// }


//       // // ✅ update login state instantly
//       // if (onLoginSuccess) {
//       //   onLoginSuccess();
//       // }


//       // ✅ Redirect Based on Subscription
//       if (subscriptionActive) {
//         navigate("/dashboard");
//       } else {
//         navigate("/payment");
//       }

//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.error || "Login Failed";
//       toast.error(errorMessage);
//     } finally {
//       setLoading(false);
//     }
//   };

// const handleOnChange = (event, name)=>{
// setLoginField({...loginField, [name]:event.target.value});
// }

//   return (
//         <div className="about__info">
//           <h4 className='loginh4'>LOGIN</h4>

//               <div className="">
//                 <input value={loginField.userName} onChange={(event)=>{handleOnChange(event, "userName")}} className='loginInput' type="text"  required placeholder="UserName" />
//               </div>

//               <div className="">
//                 <input value={loginField.password} onChange={(event)=>{handleOnChange(event, "password")}} className='loginInput' type="password"  required placeholder="Password" />
//               </div> 

//          {/* <div className="contact__button button" onClick={()=>{handleLogin()}} disabled={loading} >{loading ? "Loading..." : "LOGIN"}</div> */}
//          <div className="contact__button button" onClick={()=>{handleLogin()}} >LOGIN</div>
//  <div className="contact__button button forgotPassword " onClick={()=>handleClose()} >FORGOT PASSWORD</div> 

// <ToastContainer/>
//         </div>
       
//   )
// }

// export default Login


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";

const Login = ({ handleClose, onLoginSuccess }) => {

  const [loginField, setLoginField] = useState({
    userName: "",
    password: ""
  });

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async () => {

    if (!loginField.userName || !loginField.password) {
      toast.error("All fields are required");
      return;
    }

    try {

      setLoading(true);

      const response = await axios.post(
        `${process.env.REACT_APP_FRONTEND_URL}/auth/login`,
        loginField,
        { withCredentials: true }
      );

      const { trego, token, subscriptionActive } = response.data;

      localStorage.setItem("tregoName", trego.tregoName || "");
      localStorage.setItem("profilePic", trego.profilePic || "");
      localStorage.setItem("token", token);
      localStorage.setItem("isLogin", "true");

      if (trego.subscriptionExpiry) {
        localStorage.setItem(
          "subscriptionExpiry",
          trego.subscriptionExpiry
        );
      }

      // ✅ update login state instantly
      if (onLoginSuccess) {
        onLoginSuccess();
      }

      // ✅ redirect
      if (subscriptionActive) {
        navigate("/dashboard");
      } else {
        navigate("/payment");
      }

    } catch (err) {

      const errorMessage =
        err.response?.data?.error || "Login Failed";

      toast.error(errorMessage);

    } finally {

      setLoading(false);

    }
  };

  const handleOnChange = (event, name) => {

    setLoginField({
      ...loginField,
      [name]: event.target.value
    });

  };

  return (

    <div className="about__info">

      <h4 className='loginh4'>LOGIN</h4>

      <div>
        <input
          value={loginField.userName}
          onChange={(event) =>
            handleOnChange(event, "userName")
          }
          className='loginInput'
          type="text"
          required
          placeholder="UserName"
        />
      </div>

      <div>
        <input
          value={loginField.password}
          onChange={(event) =>
            handleOnChange(event, "password")
          }
          className='loginInput'
          type="password"
          required
          placeholder="Password"
        />
      </div>

      <div
        className="contact__button button"
        onClick={handleLogin}
        disabled={loading}
      >
        {loading ? "Loading..." : "LOGIN"}
      </div>

      <div
        className="contact__button button forgotPassword"
        onClick={() => handleClose()}
      >
        FORGOT PASSWORD
      </div>

      <ToastContainer />

    </div>
  );
};

export default Login;